import { useTranslation as useI18nTranslation } from 'react-i18next'
import { useContext } from 'react'
import { I18nContext } from './I18nProvider'
export const useTranslation = () => {
  const i18nContext = useContext(I18nContext)
  const { t, i18n } = useI18nTranslation()
  return {
    t,
    i18n,
    language: i18nContext.language,
    setLanguage: i18nContext.setLanguage,
  }
}
